'use client';

import Button from '@/components/Button';
import SectionTitle from '@/components/SectionTitle';
import { useConfig } from '@/app/contexts/ConfigContext';
import { useMediaQuery } from '@/hooks/useMediaQuery'; // importe ton hook
import CustomLink from '@/components/CustomLink';

// Only use for FR portals for now
export default function AccountSection() {
  const { config } = useConfig();
  const isMobile = useMediaQuery('(max-width: 540px)');

  if (!isMobile) return null; // Doesn't render if width > 540px, we display a link in the nav instead

  return (
    <section className='sm:mt-16 mt-8'>
      <SectionTitle>Accèder aux informations de votre compte:</SectionTitle>
      <div className='flex items-end justify-between items-center mt-4'>
        <CustomLink href='/account'>
          <Button
            variant='secondary'
            className='!px-5'
            themeBackgroundColor={config.theme.textColorDark}
            themeTextColor={config.theme.textColorLight}
          >
            Mon Compte
          </Button>
        </CustomLink>
      </div>
    </section>
  );
}
